import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEECEVLSICoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. ECE (VLSI Design & Technology)",
    shortName: "B.E. ECE (VLSI)",
    duration: "4 years",
    description: "Specialized electronics engineering program focused on Very Large Scale Integration design and semiconductor technology",
    overview: "Bachelor of Engineering in Electronics and Communication Engineering with specialization in VLSI Design & Technology (B.E. ECE VLSI) is a 4-year undergraduate program that focuses on semiconductor design and manufacturing. This course covers digital design, analog circuits, chip design, fabrication technology, and semiconductor physics, preparing students for careers in the semiconductor and chip design industry.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Strong interest in electronics and semiconductor technology"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Digital Logic Design",
          "Programming in C"
        ]
      },
      {
        year: 2,
        subjects: [
          "Electronic Devices and Circuits",
          "Digital Electronics",
          "Analog Electronics",
          "Network Theory",
          "Signals and Systems",
          "Semiconductor Physics"
        ]
      },
      {
        year: 3,
        subjects: [
          "VLSI Design",
          "Digital IC Design",
          "Analog IC Design",
          "CMOS Technology",
          "Microprocessors",
          "FPGA Design"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced VLSI Design",
          "SOC Design",
          "ASIC Design",
          "DFT and Verification",
          "Nanoscale Devices",
          "Project Work"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "VLSI Design Engineer",
        "IC Design Engineer",
        "Verification Engineer",
        "Physical Design Engineer",
        "Analog Design Engineer",
        "Digital Design Engineer",
        "DFT Engineer",
        "CAD Engineer",
        "Product Engineer",
        "Applications Engineer"
      ],
      industries: [
        "Semiconductor Companies",
        "Chip Design Houses",
        "Electronic Design Automation",
        "Consumer Electronics",
        "Automotive Electronics",
        "Telecommunications",
        "Aerospace Industry",
        "Defense Electronics",
        "Research Institutions",
        "Fabless Semiconductor Companies"
      ],
      averageSalary: "₹6-15 LPA (Fresher), ₹20-60 LPA (Experienced)",
      topRecruiters: [
        "Intel, Qualcomm, Broadcom",
        "Texas Instruments, Analog Devices",
        "Cadence, Synopsys, Mentor",
        "NVIDIA, AMD, ARM",
        "Samsung, MediaTek",
        "Infineon, NXP, STMicroelectronics"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "Indian Institute of Technology",
        location: "Various locations",
        fees: "₹8,50,000",
        ranking: "NIRF Ranking: Top 10"
      },
      {
        name: "National Institute of Technology",
        location: "Various locations",
        fees: "₹6,50,000",
        ranking: "NIRF Ranking: 15-30"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "VIT University",
        location: "Vellore",
        fees: "₹7,83,000",
        ranking: "NIRF Ranking: 15"
      }
    ],

    skills: [
      "VLSI Design Methodologies",
      "Digital IC Design",
      "Analog Circuit Design",
      "HDL Programming (Verilog/VHDL)",
      "EDA Tools (Cadence, Synopsys)",
      "Physical Design",
      "Verification Techniques",
      "FPGA Programming",
      "SOC Design",
      "Semiconductor Technology"
    ],

    futureScope: "Exceptional growth prospects with AI chips, 5G technology, IoT devices, automotive electronics, and emerging technologies like quantum computing driving unprecedented demand for VLSI engineers.",

    faqs: [
      {
        question: "What makes VLSI specialization different from regular ECE?",
        answer: "VLSI specialization focuses specifically on semiconductor chip design, IC development, and fabrication technology, providing deep expertise in the semiconductor industry."
      },
      {
        question: "Are there good opportunities in the semiconductor industry?",
        answer: "Yes, excellent opportunities exist with global semiconductor companies, chip design houses, and EDA companies offering high-paying positions with significant growth potential."
      },
      {
        question: "Can I work internationally with VLSI skills?",
        answer: "Absolutely! VLSI skills are globally in demand, with opportunities in Silicon Valley, Taiwan, South Korea, and other major semiconductor hubs worldwide."
      },
      {
        question: "What about research opportunities in VLSI?",
        answer: "Excellent research opportunities exist in advanced node technologies, quantum devices, neuromorphic computing, and next-generation semiconductor technologies."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEECEVLSICoursePage;
